import React, { useState, useEffect, useRef } from 'react';
import { Button, Typography, Radio, Progress } from 'antd';
import { TrophyOutlined, ReloadOutlined, CheckCircleOutlined, CloseCircleOutlined, SoundOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const PakistanQuiz = ({ onGameComplete }) => {
    const questions = [
        {
            question: "What is the capital city of Pakistan?",
            options: ["Karachi", "Lahore", "Islamabad", "Peshawar"],
            correct: 2
        },
        {
            question: "When did Pakistan gain independence?",
            options: ["1945", "1947", "1949", "1951"],
            correct: 1
        },
        {
            question: "What is the national language of Pakistan?",
            options: ["English", "Urdu", "Punjabi", "Sindhi"],
            correct: 1
        },
        {
            question: "Which mountain is the highest peak in Pakistan?",
            options: ["Nanga Parbat", "K2", "Tirich Mir", "Gasherbrum I"],
            correct: 1
        },
        {
            question: "What is the national animal of Pakistan?",
            options: ["Lion", "Markhor", "Snow Leopard", "Deer"],
            correct: 1
        },
        {
            question: "What is the national flower of Pakistan?",
            options: ["Rose", "Jasmine", "Lotus", "Sunflower"],
            correct: 1
        },
        {
            question: "Which river is the longest in Pakistan?",
            options: ["Indus", "Jhelum", "Chenab", "Ravi"],
            correct: 0
        },
        {
            question: "Who is known as the 'Father of the Nation' in Pakistan?",
            options: ["Allama Iqbal", "Quaid-e-Azam Muhammad Ali Jinnah", "Liaquat Ali Khan", "Sir Syed Ahmed Khan"],
            correct: 1
        },
        {
            question: "What is the national sport of Pakistan?",
            options: ["Cricket", "Hockey", "Football", "Squash"],
            correct: 1
        },
        {
            question: "Which province is the largest by area in Pakistan?",
            options: ["Punjab", "Sindh", "Khyber Pakhtunkhwa", "Balochistan"],
            correct: 3
        },
        {
            question: "What is the currency of Pakistan?",
            options: ["Rupee", "Taka", "Dinar", "Riyal"],
            correct: 0
        },
        {
            question: "Which city is known as the 'City of Lights'?",
            options: ["Lahore", "Karachi", "Islamabad", "Faisalabad"],
            correct: 1
        },
        {
            question: "What is the name of Pakistan's national anthem?",
            options: ["Pak Sarzamin", "Qaumi Tarana", "Jana Gana Mana", "Sare Jahan Se Accha"],
            correct: 1
        },
        {
            question: "Which famous historical site is located in Taxila?",
            options: ["Mohenjo-Daro", "Harappa", "Taxila Museum", "Lahore Fort"],
            correct: 2
        },
        {
            question: "What is the traditional dress of Pakistan called?",
            options: ["Sari", "Shalwar Kameez", "Kurta", "Dhoti"],
            correct: 1
        },
        {
            question: "Which desert is located in Pakistan?",
            options: ["Thar Desert", "Sahara Desert", "Gobi Desert", "Karakum Desert"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's space agency?",
            options: ["ISRO", "NASA", "SUPARCO", "ESA"],
            correct: 2
        },
        {
            question: "Which pass connects Pakistan with China?",
            options: ["Khyber Pass", "Khunjerab Pass", "Bolan Pass", "Tochi Pass"],
            correct: 1
        },
        {
            question: "What is the national bird of Pakistan?",
            options: ["Eagle", "Chukar Partridge", "Peacock", "Falcon"],
            correct: 1
        },
        {
            question: "Which Pakistani scientist won the Nobel Prize in Physics?",
            options: ["Dr. Abdul Qadeer Khan", "Dr. Atta-ur-Rahman", "Dr. Abdus Salam", "Dr. Pervez Hoodbhoy"],
            correct: 2
        },
        {
            question: "What is the name of Pakistan's largest port?",
            options: ["Gwadar Port", "Karachi Port", "Port Qasim", "Bin Qasim Port"],
            correct: 1
        },
        {
            question: "Which festival is widely celebrated in Pakistan?",
            options: ["Diwali", "Eid-ul-Fitr", "Holi", "Christmas"],
            correct: 1
        },
        {
            question: "What is the name of the famous mosque in Lahore?",
            options: ["Faisal Mosque", "Badshahi Mosque", "Shah Jahan Mosque", "Wazir Khan Mosque"],
            correct: 1
        },
        {
            question: "Which Pakistani city is known as the 'City of Gardens'?",
            options: ["Karachi", "Lahore", "Islamabad", "Multan"],
            correct: 1
        },
        {
            question: "What is the total number of provinces in Pakistan?",
            options: ["3", "4", "5", "6"],
            correct: 1
        },
        {
            question: "Which Pakistani city is known as the 'City of Sufis'?",
            options: ["Multan", "Lahore", "Karachi", "Peshawar"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's first nuclear power plant?",
            options: ["Chashma", "Karachi Nuclear Power Plant", "Tarbela", "Mangla"],
            correct: 1
        },
        {
            question: "Which Pakistani cricketer is known as 'Rawalpindi Express'?",
            options: ["Wasim Akram", "Shoaib Akhtar", "Waqar Younis", "Imran Khan"],
            correct: 1
        },
        {
            question: "What is the name of the longest highway in Pakistan?",
            options: ["Karachi-Lahore Highway", "M-2 Motorway", "Karakoram Highway", "N-5 National Highway"],
            correct: 3
        },
        {
            question: "Which Pakistani scientist developed the atomic bomb?",
            options: ["Dr. Abdus Salam", "Dr. Abdul Qadeer Khan", "Dr. Atta-ur-Rahman", "Dr. Pervez Hoodbhoy"],
            correct: 1
        },
        {
            question: "What is the name of Pakistan's largest dam?",
            options: ["Tarbela Dam", "Mangla Dam", "Warsak Dam", "Mirani Dam"],
            correct: 0
        },
        {
            question: "Which Pakistani city hosts the famous 'Shalimar Gardens'?",
            options: ["Karachi", "Lahore", "Islamabad", "Multan"],
            correct: 1
        },
        {
            question: "What is the name of Pakistan's highest military award?",
            options: ["Nishan-e-Haider", "Nishan-e-Pakistan", "Hilal-e-Jurat", "Sitara-e-Jurat"],
            correct: 0
        },
        {
            question: "Which Pakistani province borders Afghanistan?",
            options: ["Punjab", "Sindh", "Khyber Pakhtunkhwa", "Balochistan"],
            correct: 2
        },
        {
            question: "What is the name of Pakistan's largest lake?",
            options: ["Manchar Lake", "Keenjhar Lake", "Haleji Lake", "Saiful Muluk"],
            correct: 0
        },
        {
            question: "Which Pakistani actor is known as 'King Khan'?",
            options: ["Fawad Khan", "Shah Rukh Khan", "Salman Khan", "Aamir Khan"],
            correct: 1
        },
        {
            question: "What is the name of Pakistan's largest railway station?",
            options: ["Lahore Railway Station", "Karachi City Station", "Rawalpindi Railway Station", "Faisalabad Railway Station"],
            correct: 1
        },
        {
            question: "Which Pakistani mountain is known as 'Killer Mountain'?",
            options: ["K2", "Nanga Parbat", "Gasherbrum I", "Broad Peak"],
            correct: 1
        },
        {
            question: "What is the name of Pakistan's national drink?",
            options: ["Green Tea", "Lassi", "Sugarcane Juice", "Pakistani Tea"],
            correct: 3
        },
        {
            question: "Which Pakistani city is known for producing sports goods?",
            options: ["Sialkot", "Faisalabad", "Gujranwala", "Multan"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest university?",
            options: ["University of Karachi", "University of Punjab", "Quaid-e-Azam University", "NUST"],
            correct: 0
        },
        {
            question: "Which Pakistani poet wrote 'Shikwa' and 'Jawab-e-Shikwa'?",
            options: ["Faiz Ahmed Faiz", "Allama Iqbal", "Ahmed Faraz", "Mirza Ghalib"],
            correct: 1
        },
        {
            question: "What is the name of Pakistan's largest textile industry city?",
            options: ["Karachi", "Lahore", "Faisalabad", "Multan"],
            correct: 2
        },
        {
            question: "Which Pakistani city is known as 'Manchester of Pakistan'?",
            options: ["Karachi", "Lahore", "Faisalabad", "Gujranwala"],
            correct: 2
        },
        {
            question: "What is the name of Pakistan's largest desert?",
            options: ["Thar Desert", "Cholistan Desert", "Thal Desert", "Kharan Desert"],
            correct: 0
        },
        {
            question: "Which Pakistani province is known for its mineral resources?",
            options: ["Punjab", "Sindh", "Khyber Pakhtunkhwa", "Balochistan"],
            correct: 3
        },
        {
            question: "What is the name of Pakistan's largest airport?",
            options: ["Lahore Airport", "Karachi Jinnah International Airport", "Islamabad Airport", "Multan Airport"],
            correct: 1
        },
        {
            question: "Which Pakistani city is known for its pottery and ceramics?",
            options: ["Multan", "Lahore", "Karachi", "Peshawar"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest library?",
            options: ["National Library of Pakistan", "Quaid-e-Azam Library", "Lahore Public Library", "Karachi Library"],
            correct: 0
        },
        {
            question: "Which Pakistani cricketer scored the fastest century in ODIs?",
            options: ["Shahid Afridi", "Shoaib Akhtar", "Wasim Akram", "Imran Khan"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest mosque?",
            options: ["Badshahi Mosque", "Faisal Mosque", "Wazir Khan Mosque", "Shah Jahan Mosque"],
            correct: 1
        },
        {
            question: "Which Pakistani city is known as 'Gateway to Pakistan'?",
            options: ["Karachi", "Lahore", "Peshawar", "Quetta"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest stadium?",
            options: ["Gaddafi Stadium", "National Stadium Karachi", "Rawalpindi Stadium", "Multan Stadium"],
            correct: 1
        },
        {
            question: "Which Pakistani province is known for its agriculture?",
            options: ["Punjab", "Sindh", "Khyber Pakhtunkhwa", "Balochistan"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest fort?",
            options: ["Lahore Fort", "Rohtas Fort", "Ranikot Fort", "Baltit Fort"],
            correct: 2
        },
        {
            question: "Which Pakistani city is known for its traditional handicrafts?",
            options: ["Multan", "Lahore", "Karachi", "Peshawar"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest museum?",
            options: ["Lahore Museum", "National Museum Karachi", "Peshawar Museum", "Taxila Museum"],
            correct: 1
        },
        {
            question: "Which Pakistani mountain range is known as 'Roof of the World'?",
            options: ["Himalayas", "Karakoram", "Hindu Kush", "Sulaiman Range"],
            correct: 1
        },
        {
            question: "What is the name of Pakistan's largest bazaar?",
            options: ["Anarkali Bazaar", "Bohri Bazaar", "Raja Bazaar", "Itwar Bazaar"],
            correct: 0
        },
        {
            question: "Which Pakistani city is known for its leather industry?",
            options: ["Karachi", "Lahore", "Sialkot", "Faisalabad"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest canal?",
            options: ["Indus River", "Jhelum Canal", "Chashma Canal", "Lahore Canal"],
            correct: 3
        },
        {
            question: "Which Pakistani cricketer is known as 'Boom Boom'?",
            options: ["Shahid Afridi", "Shoaib Akhtar", "Wasim Akram", "Imran Khan"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest wildlife sanctuary?",
            options: ["Hingol National Park", "Kirthar National Park", "Chitral Gol National Park", "Ayub National Park"],
            correct: 1
        },
        {
            question: "Which Pakistani city is known for its mango production?",
            options: ["Multan", "Lahore", "Karachi", "Hyderabad"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest forest?",
            options: ["Changa Manga", "Chichawatni", "Kala Chitta", "Lal Suhanra"],
            correct: 0
        },
        {
            question: "Which Pakistani province is known for its natural gas reserves?",
            options: ["Punjab", "Sindh", "Khyber Pakhtunkhwa", "Balochistan"],
            correct: 1
        },
        {
            question: "What is the name of Pakistan's largest thermal power plant?",
            options: ["Bin Qasim Power Plant", "Hub Power Plant", "Uch Power Plant", "Kot Addu Power Plant"],
            correct: 0
        },
        {
            question: "Which Pakistani city is known as 'City of Saints'?",
            options: ["Multan", "Lahore", "Karachi", "Peshawar"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest steel mill?",
            options: ["Pakistan Steel Mills", "Karachi Steel", "Lahore Steel", "Multan Steel"],
            correct: 0
        },
        {
            question: "Which Pakistani cricketer is known as 'Sultan of Swing'?",
            options: ["Wasim Akram", "Waqar Younis", "Shoaib Akhtar", "Imran Khan"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest cement factory?",
            options: ["Lucky Cement", "Bestway Cement", "DG Khan Cement", "Fauji Cement"],
            correct: 0
        },
        {
            question: "Which Pakistani city is known for its traditional Ajrak?",
            options: ["Hyderabad", "Karachi", "Lahore", "Multan"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest shopping mall?",
            options: ["Dolmen Mall", "Packages Mall", "Centaurus Mall", "Lucky One Mall"],
            correct: 3
        },
        {
            question: "Which Pakistani province is known for its fruit production?",
            options: ["Punjab", "Sindh", "Khyber Pakhtunkhwa", "Balochistan"],
            correct: 2
        },
        {
            question: "What is the name of Pakistan's largest bank?",
            options: ["HBL", "UBL", "MCB", "National Bank of Pakistan"],
            correct: 3
        },
        {
            question: "Which Pakistani city is known for its traditional 'Khusa' shoes?",
            options: ["Karachi", "Lahore", "Multan", "Peshawar"],
            correct: 3
        },
        {
            question: "What is the name of Pakistan's largest sugar mill?",
            options: ["JDW Sugar Mills", "Shakarganj", "Hunza Sugar", "Al-Abbas Sugar"],
            correct: 0
        },
        {
            question: "Which Pakistani cricketer is known as 'King of Cricket'?",
            options: ["Imran Khan", "Wasim Akram", "Javed Miandad", "Inzamam-ul-Haq"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest gas field?",
            options: ["Sui Gas Field", "Mari Gas Field", "Qadirpur Gas Field", "Kandhkot Gas Field"],
            correct: 0
        },
        {
            question: "Which Pakistani city is known for its traditional 'Phulkari' embroidery?",
            options: ["Lahore", "Karachi", "Multan", "Faisalabad"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest oil refinery?",
            options: ["Pak-Arab Refinery", "Attock Refinery", "National Refinery", "Byco Refinery"],
            correct: 0
        },
        {
            question: "Which Pakistani province is known for its coal reserves?",
            options: ["Punjab", "Sindh", "Khyber Pakhtunkhwa", "Balochistan"],
            correct: 1
        },
        {
            question: "What is the name of Pakistan's largest textile mill?",
            options: ["Nishat Mills", "Gul Ahmed", "Al-Karam Textiles", "Sapphire Textiles"],
            correct: 0
        },
        {
            question: "Which Pakistani city is known for its traditional 'Chappal'?",
            options: ["Karachi", "Lahore", "Multan", "Peshawar"],
            correct: 3
        },
        {
            question: "What is the name of Pakistan's largest fertilizer factory?",
            options: ["Engro Fertilizers", "Fauji Fertilizer", "Dawood Hercules", "Fatima Fertilizer"],
            correct: 0
        },
        {
            question: "Which Pakistani cricketer is known as 'Little Master'?",
            options: ["Javed Miandad", "Zaheer Abbas", "Mohammad Yousuf", "Younis Khan"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest insurance company?",
            options: ["State Life Insurance", "Jubilee Insurance", "EFU Insurance", "Adamjee Insurance"],
            correct: 0
        },
        {
            question: "Which Pakistani city is known for its traditional 'Namda' carpets?",
            options: ["Karachi", "Lahore", "Multan", "Peshawar"],
            correct: 1
        },
        {
            question: "What is the name of Pakistan's largest telecommunication company?",
            options: ["Jazz", "Ufone", "Telenor", "Zong"],
            correct: 0
        },
        {
            question: "Which Pakistani province is known for its marble production?",
            options: ["Punjab", "Sindh", "Khyber Pakhtunkhwa", "Balochistan"],
            correct: 3
        },
        {
            question: "What is the name of Pakistan's largest airline?",
            options: ["PIA", "Air Blue", "Serene Air", "Shaheen Air"],
            correct: 0
        },
        {
            question: "Which Pakistani city is known for its traditional 'Peshawari Chappal'?",
            options: ["Karachi", "Lahore", "Multan", "Peshawar"],
            correct: 3
        },
        {
            question: "What is the name of Pakistan's largest shipping company?",
            options: ["Pakistan National Shipping Corporation", "Karachi Port Trust", "Port Qasim", "Gwadar Port"],
            correct: 0
        },
        {
            question: "Which Pakistani cricketer is known as 'The Wall'?",
            options: ["Younis Khan", "Misbah-ul-Haq", "Azhar Ali", "Asad Shafiq"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest pharmaceutical company?",
            options: ["Getz Pharma", "Searle", "Hilton Pharma", "Abbott"],
            correct: 0
        },
        {
            question: "Which Pakistani city is known for its traditional 'Kashmiri Shawl'?",
            options: ["Karachi", "Lahore", "Multan", "Peshawar"],
            correct: 1
        },
        {
            question: "What is the name of Pakistan's largest car manufacturer?",
            options: ["Suzuki", "Toyota", "Honda", "Nissan"],
            correct: 0
        },
        {
            question: "Which Pakistani province is known for its gemstone production?",
            options: ["Punjab", "Sindh", "Khyber Pakhtunkhwa", "Balochistan"],
            correct: 3
        },
        {
            question: "What is the name of Pakistan's largest food company?",
            options: ["Nestle", "Unilever", "Engro Foods", "Shan Foods"],
            correct: 0
        },
        {
            question: "Which Pakistani city is known for its traditional 'Khaddar' fabric?",
            options: ["Karachi", "Lahore", "Multan", "Faisalabad"],
            correct: 1
        },
        {
            question: "What is the name of Pakistan's largest cosmetics company?",
            options: ["Unilever", "L'Oreal", "Procter & Gamble", "Shan"],
            correct: 0
        },
        {
            question: "Which Pakistani cricketer is known as 'Captain Cool'?",
            options: ["Misbah-ul-Haq", "Sarfaraz Ahmed", "Babar Azam", "Shoaib Malik"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest construction company?",
            options: ["FWO", "NLC", "Frontier Works", "Descon"],
            correct: 0
        },
        {
            question: "Which Pakistani city is known for its traditional 'Pottery'?",
            options: ["Multan", "Lahore", "Karachi", "Hyderabad"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest dairy company?",
            options: ["Engro Foods", "Nestle", "Shakarganj", "Haleeb"],
            correct: 0
        },
        {
            question: "Which Pakistani province is known for its fish production?",
            options: ["Punjab", "Sindh", "Khyber Pakhtunkhwa", "Balochistan"],
            correct: 1
        },
        {
            question: "What is the name of Pakistan's largest paper mill?",
            options: ["Century Paper", "Packages Limited", "Kohinoor Paper", "Ittehad Paper"],
            correct: 1
        },
        {
            question: "Which Pakistani city is known for its traditional 'Blue Pottery'?",
            options: ["Multan", "Lahore", "Karachi", "Hyderabad"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest cigarette company?",
            options: ["Pakistan Tobacco Company", "Philip Morris", "Lakson Tobacco", "Khyber Tobacco"],
            correct: 0
        },
        {
            question: "Which Pakistani cricketer is known as 'The Professor'?",
            options: ["Misbah-ul-Haq", "Mohammad Hafeez", "Azhar Ali", "Younis Khan"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest electronics company?",
            options: ["Haier", "Dawlance", "Orient", "Pel"],
            correct: 0
        },
        {
            question: "Which Pakistani city is known for its traditional 'Kalamkari' art?",
            options: ["Karachi", "Lahore", "Multan", "Hyderabad"],
            correct: 3
        },
        {
            question: "What is the name of Pakistan's largest soap company?",
            options: ["Unilever", "Procter & Gamble", "Colgate", "Reckitt"],
            correct: 0
        },
        {
            question: "Which Pakistani province is known for its honey production?",
            options: ["Punjab", "Sindh", "Khyber Pakhtunkhwa", "Balochistan"],
            correct: 2
        },
        {
            question: "What is the name of Pakistan's largest paint company?",
            options: ["ICI Pakistan", "Berger Paints", "Diamond Paints", "Jotun Paints"],
            correct: 0
        },
        {
            question: "Which Pakistani city is known for its traditional 'Woodwork'?",
            options: ["Karachi", "Lahore", "Multan", "Peshawar"],
            correct: 1
        },
        {
            question: "What is the name of Pakistan's largest glass company?",
            options: ["Ghani Glass", "Fauji Glass", "Pak Glass", "Ruby Glass"],
            correct: 0
        },
        {
            question: "Which Pakistani cricketer is known as 'The King'?",
            options: ["Babar Azam", "Fakhar Zaman", "Imam-ul-Haq", "Mohammad Rizwan"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest match company?",
            options: ["Pak Match", "Sind Match", "Lahore Match", "Karachi Match"],
            correct: 0
        },
        {
            question: "Which Pakistani city is known for its traditional 'Copper Work'?",
            options: ["Karachi", "Lahore", "Multan", "Peshawar"],
            correct: 3
        },
        {
            question: "What is the name of Pakistan's largest biscuit company?",
            options: ["Peek Freans", "English Biscuits", "Shan Foods", "Bake Parlor"],
            correct: 0
        },
        {
            question: "Which Pakistani province is known for its wheat production?",
            options: ["Punjab", "Sindh", "Khyber Pakhtunkhwa", "Balochistan"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest rice company?",
            options: ["Taj Foods", "Shan Foods", "National Foods", "Kohinoor Foods"],
            correct: 0
        },
        {
            question: "Which Pakistani city is known for its traditional 'Silver Work'?",
            options: ["Karachi", "Lahore", "Multan", "Peshawar"],
            correct: 1
        },
        {
            question: "What is the name of Pakistan's largest ice cream company?",
            options: ["Omore", "Walls", "Polka", "Hico"],
            correct: 0
        },
        {
            question: "Which Pakistani cricketer is known as 'The Magician'?",
            options: ["Saeed Ajmal", "Shahid Afridi", "Mohammad Hafeez", "Shadab Khan"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest juice company?",
            options: ["Shan Foods", "National Foods", "Shezan", "Nestle"],
            correct: 2
        },
        {
            question: "Which Pakistani province is known for its cotton production?",
            options: ["Punjab", "Sindh", "Khyber Pakhtunkhwa", "Balochistan"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest tea company?",
            options: ["Tapal", "Lipton", "Brooke Bond", "Vital Tea"],
            correct: 0
        },
        {
            question: "Which Pakistani city is known for its traditional 'Brass Work'?",
            options: ["Karachi", "Lahore", "Multan", "Peshawar"],
            correct: 1
        },
        {
            question: "What is the name of Pakistan's largest spice company?",
            options: ["Shan Foods", "National Foods", "Mehran Spices", "National Spices"],
            correct: 0
        },
        {
            question: "Which Pakistani cricketer is known as 'The Finisher'?",
            options: ["Shahid Afridi", "Shoaib Malik", "Umar Akmal", "Asif Ali"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest pickle company?",
            options: ["Shan Foods", "National Foods", "Mehran Foods", "Ahmed Foods"],
            correct: 0
        },
        {
            question: "Which Pakistani province is known for its rice production?",
            options: ["Punjab", "Sindh", "Khyber Pakhtunkhwa", "Balochistan"],
            correct: 1
        },
        {
            question: "What is the name of Pakistan's largest ketchup company?",
            options: ["Shan Foods", "National Foods", "Mitchell's", "Kissan"],
            correct: 2
        },
        {
            question: "Which Pakistani city is known for its traditional 'Embroidery'?",
            options: ["Karachi", "Lahore", "Multan", "Hyderabad"],
            correct: 3
        },
        {
            question: "What is the name of Pakistan's largest jam company?",
            options: ["Shan Foods", "National Foods", "Mitchell's", "Kissan"],
            correct: 2
        },
        {
            question: "Which Pakistani cricketer is known as 'The Rock'?",
            options: ["Azhar Ali", "Younis Khan", "Misbah-ul-Haq", "Mohammad Hafeez"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest honey company?",
            options: ["Shan Foods", "National Foods", "Honey World", "Honey Bee"],
            correct: 0
        },
        {
            question: "Which Pakistani province is known for its sugarcane production?",
            options: ["Punjab", "Sindh", "Khyber Pakhtunkhwa", "Balochistan"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest chocolate company?",
            options: ["Cadbury", "Nestle", "Rahat", "Eclair"],
            correct: 0
        },
        {
            question: "Which Pakistani city is known for its traditional 'Carpet Weaving'?",
            options: ["Karachi", "Lahore", "Multan", "Peshawar"],
            correct: 1
        },
        {
            question: "What is the name of Pakistan's largest chips company?",
            options: ["Lays", "Kurkure", "Cheetos", "Doritos"],
            correct: 0
        },
        {
            question: "Which Pakistani cricketer is known as 'The Gentleman'?",
            options: ["Misbah-ul-Haq", "Younis Khan", "Azhar Ali", "Mohammad Hafeez"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest mineral water company?",
            options: ["Nestle Pure Life", "Aquafina", "Kinley", "Dasani"],
            correct: 0
        },
        {
            question: "Which Pakistani city is known as 'Heart of Pakistan'?",
            options: ["Lahore", "Karachi", "Islamabad", "Multan"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest oil field?",
            options: ["Toot Oil Field", "Dhurnal Oil Field", "Meyal Oil Field", "Adhi Oil Field"],
            correct: 0
        },
        {
            question: "Which Pakistani cricketer is known as 'The Pathan'?",
            options: ["Yasir Shah", "Shadab Khan", "Mohammad Amir", "Shahid Afridi"],
            correct: 1
        },
        {
            question: "What is the name of Pakistan's largest cement company?",
            options: ["Lucky Cement", "Bestway Cement", "DG Khan Cement", "Fauji Cement"],
            correct: 0
        },
        {
            question: "Which Pakistani city is known for its traditional 'Kalam' art?",
            options: ["Karachi", "Lahore", "Multan", "Hyderabad"],
            correct: 1
        },
        {
            question: "What is the name of Pakistan's largest power distribution company?",
            options: ["K-Electric", "LESCO", "IESCO", "PESCO"],
            correct: 0
        },
        {
            question: "Which Pakistani province is known for its date production?",
            options: ["Punjab", "Sindh", "Khyber Pakhtunkhwa", "Balochistan"],
            correct: 1
        },
        {
            question: "What is the name of Pakistan's largest insurance company?",
            options: ["State Life Insurance", "Jubilee Insurance", "EFU Insurance", "Adamjee Insurance"],
            correct: 0
        },
        {
            question: "Which Pakistani city is known for its traditional 'Lacquer Work'?",
            options: ["Karachi", "Lahore", "Multan", "Peshawar"],
            correct: 1
        },
        {
            question: "What is the name of Pakistan's largest mobile phone company?",
            options: ["Jazz", "Ufone", "Telenor", "Zong"],
            correct: 0
        },
        {
            question: "Which Pakistani cricketer is known as 'The Wicket Keeper'?",
            options: ["Mohammad Rizwan", "Sarfaraz Ahmed", "Kamran Akmal", "Umar Akmal"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest fertilizer company?",
            options: ["Engro Fertilizers", "Fauji Fertilizer", "Dawood Hercules", "Fatima Fertilizer"],
            correct: 0
        },
        {
            question: "Which Pakistani city is known for its traditional 'Mirror Work'?",
            options: ["Karachi", "Lahore", "Multan", "Hyderabad"],
            correct: 3
        },
        {
            question: "What is the name of Pakistan's largest sugar company?",
            options: ["JDW Sugar Mills", "Shakarganj", "Hunza Sugar", "Al-Abbas Sugar"],
            correct: 0
        },
        {
            question: "Which Pakistani province is known for its apricot production?",
            options: ["Punjab", "Sindh", "Khyber Pakhtunkhwa", "Balochistan"],
            correct: 2
        },
        {
            question: "What is the name of Pakistan's largest textile company?",
            options: ["Nishat Mills", "Gul Ahmed", "Al-Karam Textiles", "Sapphire Textiles"],
            correct: 0
        },
        {
            question: "Which Pakistani city is known for its traditional 'Camel Leather' products?",
            options: ["Karachi", "Lahore", "Multan", "Peshawar"],
            correct: 3
        },
        {
            question: "What is the name of Pakistan's largest banking company?",
            options: ["HBL", "UBL", "MCB", "National Bank of Pakistan"],
            correct: 3
        },
        {
            question: "Which Pakistani cricketer is known as 'The All-Rounder'?",
            options: ["Shahid Afridi", "Shoaib Malik", "Mohammad Hafeez", "Shadab Khan"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest oil company?",
            options: ["PPL", "OGDCL", "Pakistan State Oil", "Attock Refinery"],
            correct: 2
        },
        {
            question: "Which Pakistani city is known for its traditional 'Stone Carving'?",
            options: ["Karachi", "Lahore", "Multan", "Peshawar"],
            correct: 1
        },
        {
            question: "What is the name of Pakistan's largest telecom infrastructure company?",
            options: ["PTCL", "Ufone", "Telenor", "Zong"],
            correct: 0
        },
        {
            question: "Which Pakistani province is known for its cherry production?",
            options: ["Punjab", "Sindh", "Khyber Pakhtunkhwa", "Balochistan"],
            correct: 2
        },
        {
            question: "What is the name of Pakistan's largest gas company?",
            options: ["SSGC", "SNGPL", "Sui Northern Gas", "Sui Southern Gas"],
            correct: 0
        },
        {
            question: "Which Pakistani city is known for its traditional 'Bone Work'?",
            options: ["Karachi", "Lahore", "Multan", "Peshawar"],
            correct: 1
        },
        {
            question: "What is the name of Pakistan's largest dry port?",
            options: ["Port Qasim", "Karachi Port", "Sialkot Dry Port", "Lahore Dry Port"],
            correct: 2
        },
        {
            question: "Which Pakistani cricketer is known as 'The Speedster'?",
            options: ["Shoaib Akhtar", "Mohammad Amir", "Waqar Younis", "Wasim Akram"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest fruit market?",
            options: ["Lahore Fruit Market", "Karachi Fruit Market", "Faisalabad Fruit Market", "Multan Fruit Market"],
            correct: 0
        },
        {
            question: "Which Pakistani province is known for its peach production?",
            options: ["Punjab", "Sindh", "Khyber Pakhtunkhwa", "Balochistan"],
            correct: 2
        },
        {
            question: "What is the name of Pakistan's largest vegetable market?",
            options: ["Lahore Vegetable Market", "Karachi Vegetable Market", "Faisalabad Vegetable Market", "Multan Vegetable Market"],
            correct: 0
        },
        {
            question: "Which Pakistani city is known for its traditional 'Block Printing'?",
            options: ["Karachi", "Lahore", "Multan", "Hyderabad"],
            correct: 1
        },
        {
            question: "What is the name of Pakistan's largest wholesale market?",
            options: ["Lahore Wholesale Market", "Karachi Wholesale Market", "Faisalabad Wholesale Market", "Multan Wholesale Market"],
            correct: 0
        },
        {
            question: "Which Pakistani cricketer is known as 'The Spinner'?",
            options: ["Saeed Ajmal", "Yasir Shah", "Shadab Khan", "Mohammad Nawaz"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest fish market?",
            options: ["Lahore Fish Market", "Karachi Fish Market", "Faisalabad Fish Market", "Multan Fish Market"],
            correct: 1
        },
        {
            question: "Which Pakistani province is known for its apple production?",
            options: ["Punjab", "Sindh", "Khyber Pakhtunkhwa", "Balochistan"],
            correct: 2
        },
        {
            question: "What is the name of Pakistan's largest meat market?",
            options: ["Lahore Meat Market", "Karachi Meat Market", "Faisalabad Meat Market", "Multan Meat Market"],
            correct: 0
        },
        {
            question: "Which Pakistani city is known for its traditional 'Tie and Dye'?",
            options: ["Karachi", "Lahore", "Multan", "Hyderabad"],
            correct: 3
        },
        {
            question: "What is the name of Pakistan's largest flower market?",
            options: ["Lahore Flower Market", "Karachi Flower Market", "Faisalabad Flower Market", "Multan Flower Market"],
            correct: 0
        },
        {
            question: "Which Pakistani cricketer is known as 'The Batsman'?",
            options: ["Babar Azam", "Fakhar Zaman", "Mohammad Rizwan", "Imam-ul-Haq"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest poultry market?",
            options: ["Lahore Poultry Market", "Karachi Poultry Market", "Faisalabad Poultry Market", "Multan Poultry Market"],
            correct: 0
        },
        {
            question: "Which Pakistani province is known for its almond production?",
            options: ["Punjab", "Sindh", "Khyber Pakhtunkhwa", "Balochistan"],
            correct: 3
        },
        {
            question: "What is the name of Pakistan's largest grain market?",
            options: ["Lahore Grain Market", "Karachi Grain Market", "Faisalabad Grain Market", "Multan Grain Market"],
            correct: 0
        },
        {
            question: "Which Pakistani city is known for its traditional 'Embroidery Work'?",
            options: ["Karachi", "Lahore", "Multan", "Hyderabad"],
            correct: 3
        },
        {
            question: "What is the name of Pakistan's largest spice market?",
            options: ["Lahore Spice Market", "Karachi Spice Market", "Faisalabad Spice Market", "Multan Spice Market"],
            correct: 0
        },
        {
            question: "Which Pakistani cricketer is known as 'The Opener'?",
            options: ["Fakhar Zaman", "Imam-ul-Haq", "Babar Azam", "Mohammad Rizwan"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest cloth market?",
            options: ["Lahore Cloth Market", "Karachi Cloth Market", "Faisalabad Cloth Market", "Multan Cloth Market"],
            correct: 0
        },
        {
            question: "Which Pakistani province is known for its pistachio production?",
            options: ["Punjab", "Sindh", "Khyber Pakhtunkhwa", "Balochistan"],
            correct: 3
        },
        {
            question: "What is the name of Pakistan's largest jewelry market?",
            options: ["Lahore Jewelry Market", "Karachi Jewelry Market", "Faisalabad Jewelry Market", "Multan Jewelry Market"],
            correct: 0
        },
        {
            question: "Which Pakistani city is known for its traditional 'Wooden Carving'?",
            options: ["Karachi", "Lahore", "Multan", "Peshawar"],
            correct: 1
        },
        {
            question: "What is the name of Pakistan's largest electronics market?",
            options: ["Lahore Electronics Market", "Karachi Electronics Market", "Faisalabad Electronics Market", "Multan Electronics Market"],
            correct: 0
        },
        {
            question: "Which Pakistani cricketer is known as 'The Fast Bowler'?",
            options: ["Shoaib Akhtar", "Mohammad Amir", "Waqar Younis", "Wasim Akram"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest book market?",
            options: ["Lahore Book Market", "Karachi Book Market", "Faisalabad Book Market", "Multan Book Market"],
            correct: 0
        },
        {
            question: "Which Pakistani province is known for its walnut production?",
            options: ["Punjab", "Sindh", "Khyber Pakhtunkhwa", "Balochistan"],
            correct: 2
        },
        {
            question: "What is the name of Pakistan's largest shoe market?",
            options: ["Lahore Shoe Market", "Karachi Shoe Market", "Faisalabad Shoe Market", "Multan Shoe Market"],
            correct: 0
        },
        {
            question: "Which Pakistani city is known for its traditional 'Metal Work'?",
            options: ["Karachi", "Lahore", "Multan", "Peshawar"],
            correct: 1
        },
        {
            question: "What is the name of Pakistan's largest furniture market?",
            options: ["Lahore Furniture Market", "Karachi Furniture Market", "Faisalabad Furniture Market", "Multan Furniture Market"],
            correct: 0
        },
        {
            question: "Which Pakistani cricketer is known as 'The Wicket Keeper Batsman'?",
            options: ["Mohammad Rizwan", "Sarfaraz Ahmed", "Kamran Akmal", "Umar Akmal"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest carpet market?",
            options: ["Lahore Carpet Market", "Karachi Carpet Market", "Faisalabad Carpet Market", "Multan Carpet Market"],
            correct: 0
        },
        {
            question: "Which Pakistani province is known for its olive production?",
            options: ["Punjab", "Sindh", "Khyber Pakhtunkhwa", "Balochistan"],
            correct: 3
        },
        {
            question: "What is the name of Pakistan's largest toy market?",
            options: ["Lahore Toy Market", "Karachi Toy Market", "Faisalabad Toy Market", "Multan Toy Market"],
            correct: 0
        },
        {
            question: "Which Pakistani city is known for its traditional 'Glass Work'?",
            options: ["Karachi", "Lahore", "Multan", "Peshawar"],
            correct: 1
        },
        {
            question: "What is the name of Pakistan's largest stationery market?",
            options: ["Lahore Stationery Market", "Karachi Stationery Market", "Faisalabad Stationery Market", "Multan Stationery Market"],
            correct: 0
        },
        {
            question: "Which Pakistani cricketer is known as 'The Left Arm Bowler'?",
            options: ["Mohammad Amir", "Wasim Akram", "Shoaib Akhtar", "Waqar Younis"],
            correct: 1
        },
        {
            question: "What is the name of Pakistan's largest hardware market?",
            options: ["Lahore Hardware Market", "Karachi Hardware Market", "Faisalabad Hardware Market", "Multan Hardware Market"],
            correct: 0
        },
        {
            question: "Which Pakistani province is known for its fig production?",
            options: ["Punjab", "Sindh", "Khyber Pakhtunkhwa", "Balochistan"],
            correct: 3
        },
        {
            question: "What is the name of Pakistan's largest bicycle market?",
            options: ["Lahore Bicycle Market", "Karachi Bicycle Market", "Faisalabad Bicycle Market", "Multan Bicycle Market"],
            correct: 0
        },
        {
            question: "Which Pakistani city is known for its traditional 'Clay Work'?",
            options: ["Karachi", "Lahore", "Multan", "Hyderabad"],
            correct: 2
        },
        {
            question: "What is the name of Pakistan's largest motorcycle market?",
            options: ["Lahore Motorcycle Market", "Karachi Motorcycle Market", "Faisalabad Motorcycle Market", "Multan Motorcycle Market"],
            correct: 0
        },
        {
            question: "Which Pakistani cricketer is known as 'The Right Arm Bowler'?",
            options: ["Shoaib Akhtar", "Waqar Younis", "Mohammad Amir", "Wasim Akram"],
            correct: 1
        },
        {
            question: "What is the name of Pakistan's largest car market?",
            options: ["Lahore Car Market", "Karachi Car Market", "Faisalabad Car Market", "Multan Car Market"],
            correct: 0
        },
        {
            question: "Which Pakistani province is known for its pomegranate production?",
            options: ["Punjab", "Sindh", "Khyber Pakhtunkhwa", "Balochistan"],
            correct: 3
        },
        {
            question: "What is the name of Pakistan's largest mobile phone market?",
            options: ["Lahore Mobile Phone Market", "Karachi Mobile Phone Market", "Faisalabad Mobile Phone Market", "Multan Mobile Phone Market"],
            correct: 0
        },
        {
            question: "Which Pakistani city is known for its traditional 'Bead Work'?",
            options: ["Karachi", "Lahore", "Multan", "Hyderabad"],
            correct: 3
        },
        {
            question: "What is the name of Pakistan's largest computer market?",
            options: ["Lahore Computer Market", "Karachi Computer Market", "Faisalabad Computer Market", "Multan Computer Market"],
            correct: 0
        },
        {
            question: "Which Pakistani cricketer is known as 'The Leg Spinner'?",
            options: ["Yasir Shah", "Shadab Khan", "Saeed Ajmal", "Mohammad Nawaz"],
            correct: 0
        },
        {
            question: "What is the name of Pakistan's largest medical equipment market?",
            options: ["Lahore Medical Equipment Market", "Karachi Medical Equipment Market", "Faisalabad Medical Equipment Market", "Multan Medical Equipment Market"],
            correct: 0
        },
        {
            question: "Which Pakistani province is known for its grape production?",
            options: ["Punjab", "Sindh", "Khyber Pakhtunkhwa", "Balochistan"],
            correct: 2
        }
    ];

    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [score, setScore] = useState(0);
    const [selectedAnswer, setSelectedAnswer] = useState(null);
    const [showResult, setShowResult] = useState(false);
    const [showStartScreen, setShowStartScreen] = useState(true);
    const [gameStarted, setGameStarted] = useState(false);
    const [gameEnded, setGameEnded] = useState(false);
    const [usedQuestions, setUsedQuestions] = useState([]);
    const [currentQuestion, setCurrentQuestion] = useState(null);
    const [timeLeft, setTimeLeft] = useState(30);
    const [answered, setAnswered] = useState(false);
    const [isReading, setIsReading] = useState(false);
    const speechSynthesisRef = useRef(null);
    const clockTickAudioRef = useRef(null);
    const correctAudioRef = useRef(null);
    const wrongAudioRef = useRef(null);

    // Shuffle and select random questions
    const getRandomQuestion = () => {
        const availableQuestions = questions.filter((_, index) => !usedQuestions.includes(index));
        if (availableQuestions.length === 0) {
            // Reset if all questions used
            setUsedQuestions([]);
            return questions[Math.floor(Math.random() * questions.length)];
        }
        const randomIndex = Math.floor(Math.random() * availableQuestions.length);
        const question = availableQuestions[randomIndex];
        const originalIndex = questions.findIndex(q => q.question === question.question);
        setUsedQuestions(prev => [...prev, originalIndex]);
        return question;
    };

    const startGame = () => {
        // Stop any ongoing speech
        stopReading();
        
        setShowStartScreen(false);
        setGameStarted(true);
        setGameEnded(false);
        setScore(0);
        setCurrentQuestionIndex(0);
        setUsedQuestions([]);
        setSelectedAnswer(null);
        setShowResult(false);
        setTimeLeft(30);
        setAnswered(false);
        setIsReading(false);
        setCurrentQuestion(getRandomQuestion());
        
        // Start background clock-tick sound
        if (clockTickAudioRef.current) {
            try {
                clockTickAudioRef.current.currentTime = 0; // Reset to start
                clockTickAudioRef.current.play().catch(error => {
                    // Handle autoplay restrictions
                    console.log('Could not play clock-tick sound:', error);
                });
            } catch (error) {
                console.log('Error playing clock-tick sound:', error);
            }
        }
    };

    useEffect(() => {
        if (!gameStarted || gameEnded || !currentQuestion) return;

        const timer = setInterval(() => {
            setTimeLeft(prev => {
                if (prev <= 1) {
                    handleTimeUp();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [gameStarted, gameEnded, currentQuestion]);

    const handleTimeUp = () => {
        // Stop any ongoing speech
        stopReading();
        
        setAnswered(true);
        setShowResult(true);
        
        // Play wrong sound when time runs out
        if (wrongAudioRef.current) {
            try {
                wrongAudioRef.current.currentTime = 0; // Reset to start
                wrongAudioRef.current.play().catch(error => {
                    // Handle autoplay restrictions
                    console.log('Could not play wrong sound:', error);
                });
            } catch (error) {
                console.log('Error playing wrong sound:', error);
            }
        }
        
        setTimeout(() => {
            nextQuestion();
        }, 2000);
    };

    const handleAnswer = (answerIndex) => {
        if (answered) return;
        
        // Stop any ongoing speech
        stopReading();
        
        setSelectedAnswer(answerIndex);
        setAnswered(true);
        
        const isCorrect = answerIndex === currentQuestion.correct;
        if (isCorrect) {
            setScore(prev => prev + 10);
            
            // Play correct sound
            if (correctAudioRef.current) {
                try {
                    correctAudioRef.current.currentTime = 0; // Reset to start
                    correctAudioRef.current.play().catch(error => {
                        // Handle autoplay restrictions
                        console.log('Could not play correct sound:', error);
                    });
                } catch (error) {
                    console.log('Error playing correct sound:', error);
                }
            }
        } else {
            // Play wrong sound
            if (wrongAudioRef.current) {
                try {
                    wrongAudioRef.current.currentTime = 0; // Reset to start
                    wrongAudioRef.current.play().catch(error => {
                        // Handle autoplay restrictions
                        console.log('Could not play wrong sound:', error);
                    });
                } catch (error) {
                    console.log('Error playing wrong sound:', error);
                }
            }
        }
        
        setShowResult(true);
        
        setTimeout(() => {
            nextQuestion();
        }, 2000);
    };

    const nextQuestion = () => {
        // Stop any ongoing speech
        stopReading();
        
        if (currentQuestionIndex >= 24) {
            // Game over after 25 questions
            setGameEnded(true);
            setGameStarted(false);
            
            // Stop background clock-tick sound
            if (clockTickAudioRef.current) {
                clockTickAudioRef.current.pause();
                clockTickAudioRef.current.currentTime = 0;
            }
            
            if (onGameComplete) {
                setTimeout(() => onGameComplete(score), 500);
            }
        } else {
            setCurrentQuestionIndex(prev => prev + 1);
            setSelectedAnswer(null);
            setShowResult(false);
            setTimeLeft(30);
            setAnswered(false);
            setCurrentQuestion(getRandomQuestion());
        }
    };

    const readQuestion = () => {
        if (!currentQuestion) return;
        
        // Stop any ongoing speech
        if (speechSynthesisRef.current) {
            window.speechSynthesis.cancel();
        }
        
        // Check if browser supports speech synthesis
        if ('speechSynthesis' in window) {
            // Get available voices
            const voices = window.speechSynthesis.getVoices();
            
            // Try to find a natural-sounding voice (prefer female voices with natural names)
            let selectedVoice = null;
            
            // Priority order: natural voices, then female voices, then default
            const preferredVoices = [
                'Google UK English Female',
                'Microsoft Zira - English (United States)',
                'Microsoft Hazel - English (Great Britain)',
                'Samantha',
                'Karen',
                'Victoria',
                'Alex',
                'Siri'
            ];
            
            // Try to find preferred voice
            for (const preferredName of preferredVoices) {
                const voice = voices.find(v => v.name.includes(preferredName) || v.name === preferredName);
                if (voice) {
                    selectedVoice = voice;
                    break;
                }
            }
            
            // If no preferred voice found, try to find any female English voice
            if (!selectedVoice) {
                selectedVoice = voices.find(v => 
                    v.lang.startsWith('en') && 
                    (v.name.toLowerCase().includes('female') || 
                     v.name.toLowerCase().includes('zira') ||
                     v.name.toLowerCase().includes('hazel') ||
                     v.name.toLowerCase().includes('samantha'))
                );
            }
            
            // If still no voice, use default
            if (!selectedVoice) {
                selectedVoice = voices.find(v => v.lang.startsWith('en')) || voices[0];
            }
            
            const utterance = new SpeechSynthesisUtterance(currentQuestion.question);
            utterance.lang = 'en-US';
            utterance.rate = 0.95; // Slightly slower for more natural sound
            utterance.pitch = 1.0; // Natural pitch
            utterance.volume = 1;
            
            // Set the voice if available
            if (selectedVoice) {
                utterance.voice = selectedVoice;
            }
            
            utterance.onstart = () => {
                setIsReading(true);
            };
            
            utterance.onend = () => {
                setIsReading(false);
                speechSynthesisRef.current = null;
            };
            
            utterance.onerror = () => {
                setIsReading(false);
                speechSynthesisRef.current = null;
            };
            
            speechSynthesisRef.current = utterance;
            
            // Load voices if not already loaded (some browsers need this)
            if (voices.length === 0) {
                window.speechSynthesis.onvoiceschanged = () => {
                    const updatedVoices = window.speechSynthesis.getVoices();
                    if (updatedVoices.length > 0 && selectedVoice) {
                        const voice = updatedVoices.find(v => v.name === selectedVoice.name);
                        if (voice) utterance.voice = voice;
                    }
                    window.speechSynthesis.speak(utterance);
                };
            } else {
                window.speechSynthesis.speak(utterance);
            }
        } else {
            alert('Text-to-speech is not supported in your browser.');
        }
    };

    const stopReading = () => {
        if (speechSynthesisRef.current) {
            window.speechSynthesis.cancel();
            speechSynthesisRef.current = null;
            setIsReading(false);
        }
    };

    const readText = (text, callback) => {
        // Stop any ongoing speech
        if (speechSynthesisRef.current) {
            window.speechSynthesis.cancel();
        }
        
        // Check if browser supports speech synthesis
        if ('speechSynthesis' in window) {
            // Get available voices
            const voices = window.speechSynthesis.getVoices();
            
            // Try to find a natural-sounding voice
            let selectedVoice = null;
            
            const preferredVoices = [
                'Google UK English Female',
                'Microsoft Zira - English (United States)',
                'Microsoft Hazel - English (Great Britain)',
                'Samantha',
                'Karen',
                'Victoria',
                'Alex',
                'Siri'
            ];
            
            for (const preferredName of preferredVoices) {
                const voice = voices.find(v => v.name.includes(preferredName) || v.name === preferredName);
                if (voice) {
                    selectedVoice = voice;
                    break;
                }
            }
            
            if (!selectedVoice) {
                selectedVoice = voices.find(v => 
                    v.lang.startsWith('en') && 
                    (v.name.toLowerCase().includes('female') || 
                     v.name.toLowerCase().includes('zira') ||
                     v.name.toLowerCase().includes('hazel') ||
                     v.name.toLowerCase().includes('samantha'))
                );
            }
            
            if (!selectedVoice) {
                selectedVoice = voices.find(v => v.lang.startsWith('en')) || voices[0];
            }
            
            const utterance = new SpeechSynthesisUtterance(text);
            utterance.lang = 'en-US';
            utterance.rate = 0.95;
            utterance.pitch = 1.0;
            utterance.volume = 1;
            
            if (selectedVoice) {
                utterance.voice = selectedVoice;
            }
            
            utterance.onstart = () => {
                if (callback) callback(true);
            };
            
            utterance.onend = () => {
                if (callback) callback(false);
                speechSynthesisRef.current = null;
            };
            
            utterance.onerror = () => {
                if (callback) callback(false);
                speechSynthesisRef.current = null;
            };
            
            speechSynthesisRef.current = utterance;
            
            if (voices.length === 0) {
                window.speechSynthesis.onvoiceschanged = () => {
                    const updatedVoices = window.speechSynthesis.getVoices();
                    if (updatedVoices.length > 0 && selectedVoice) {
                        const voice = updatedVoices.find(v => v.name === selectedVoice.name);
                        if (voice) utterance.voice = voice;
                    }
                    window.speechSynthesis.speak(utterance);
                };
            } else {
                window.speechSynthesis.speak(utterance);
            }
        } else {
            alert('Text-to-speech is not supported in your browser.');
        }
    };

    const readAllOptions = () => {
        if (!currentQuestion) return;
        
        const optionsText = currentQuestion.options.map((opt, idx) => {
            const optionLabel = String.fromCharCode(65 + idx); // A, B, C, D
            return `${optionLabel}. ${opt}`;
        }).join('. ');
        
        const fullText = `${currentQuestion.question}. Options: ${optionsText}`;
        readText(fullText, setIsReading);
    };

    const readOption = (optionText, optionIndex) => {
        const optionLabel = String.fromCharCode(65 + optionIndex); // A, B, C, D
        const text = `${optionLabel}. ${optionText}`;
        readText(text, null);
    };

    // Initialize audio files
    useEffect(() => {
        clockTickAudioRef.current = new Audio('/sounds/clock-tick.mp3');
        clockTickAudioRef.current.volume = 0.3; // Set volume to 30% for background sound
        clockTickAudioRef.current.loop = true; // Loop the clock-tick sound
        
        correctAudioRef.current = new Audio('/sounds/correct.mp3');
        correctAudioRef.current.volume = 0.7; // Set volume to 70%
        
        wrongAudioRef.current = new Audio('/sounds/fail.mp3');
        wrongAudioRef.current.volume = 0.7; // Set volume to 70%
        
        return () => {
            if (clockTickAudioRef.current) {
                clockTickAudioRef.current.pause();
                clockTickAudioRef.current = null;
            }
            if (correctAudioRef.current) {
                correctAudioRef.current.pause();
                correctAudioRef.current = null;
            }
            if (wrongAudioRef.current) {
                wrongAudioRef.current.pause();
                wrongAudioRef.current = null;
            }
        };
    }, []);

    // Load voices when component mounts
    useEffect(() => {
        if ('speechSynthesis' in window) {
            // Some browsers need this to load voices
            const loadVoices = () => {
                window.speechSynthesis.getVoices();
            };
            loadVoices();
            window.speechSynthesis.onvoiceschanged = loadVoices;
            
            return () => {
                window.speechSynthesis.onvoiceschanged = null;
            };
        }
    }, []);

    // Cleanup speech when component unmounts or game ends
    useEffect(() => {
        return () => {
            if (speechSynthesisRef.current) {
                window.speechSynthesis.cancel();
            }
        };
    }, []);

    const getScoreMessage = () => {
        if (score >= 225) return "🏆 Outstanding! You're a Pakistan expert!";
        if (score >= 175) return "⭐ Excellent! Great knowledge!";
        if (score >= 125) return "👍 Good! Keep learning!";
        if (score >= 75) return "📚 Not bad! Study more about Pakistan!";
        return "💪 Keep practicing!";
    };

    // Cover page with image
    if (showStartScreen && !gameStarted && !gameEnded) {
        return (
            <div style={{
                textAlign: 'center',
                padding: '0',
                background: 'rgba(255, 255, 255, 0.95)',
                borderRadius: '12px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                border: '1px solid rgba(24, 144, 255, 0.2)',
                overflow: 'hidden'
            }}>
                {/* Game Preview Image */}
                <div style={{
                    width: '100%',
                    height: '400px',
                    background: 'linear-gradient(180deg, #87CEEB 0%, #E0F6FF 30%, #98D8C8 70%, #90EE90 100%)',
                    position: 'relative',
                    overflow: 'hidden',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <img 
                        src="/assets/images/pakistan-quiz.jpg" 
                        alt="Pakistan Quiz Game"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                            objectPosition: 'center'
                        }}
                        onError={(e) => {
                            // Fallback if image doesn't exist
                            e.target.style.display = 'none';
                        }}
                    />
                </div>
                
                {/* Start Button Section */}
                <div style={{
                    padding: '20px 16px',
                    background: 'rgba(255, 255, 255, 0.95)'
                }}>
                    <Title level={5} style={{ marginBottom: '10px', color: '#1890ff', fontSize: '16px' }}>
                        🇵🇰 Pakistan General Knowledge Quiz
                    </Title>
                    <Text style={{ 
                        fontSize: '13px', 
                        color: '#666',
                        display: 'block',
                        marginBottom: '12px'
                    }}>
                        Test your knowledge about Pakistan! Answer 25 random questions.
                    </Text>
                    <Button
                        type="primary"
                        size="middle"
                        icon={<TrophyOutlined />}
                        onClick={startGame}
                        style={{
                            height: '36px',
                            fontSize: '13px',
                            fontWeight: 600,
                            borderRadius: '8px',
                            padding: '0 20px',
                            background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                            border: 'none',
                            boxShadow: '0 4px 12px rgba(24, 144, 255, 0.3)'
                        }}
                    >
                        Start Quiz
                    </Button>
                </div>
            </div>
        );
    }

    if (!gameStarted && !gameEnded) {
        return null;
    }

    if (gameEnded) {
        return (
            <div style={{
                textAlign: 'center',
                padding: '30px 20px',
                background: 'rgba(255, 255, 255, 0.95)',
                borderRadius: '12px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                border: '1px solid rgba(24, 144, 255, 0.2)'
            }}>
                <TrophyOutlined style={{ fontSize: '50px', color: '#ffd700', marginBottom: '15px' }} />
                <Title level={4} style={{ marginBottom: '10px', color: '#1890ff', fontSize: '20px' }}>
                    Quiz Complete!
                </Title>
                <Text style={{ fontSize: '32px', fontWeight: 'bold', color: '#52c41a', display: 'block', marginBottom: '10px' }}>
                    Score: {score}/250
                </Text>
                <Text style={{ fontSize: '16px', color: '#666', display: 'block', marginBottom: '20px' }}>
                    {getScoreMessage()}
                </Text>
                <Button
                    type="primary"
                    size="large"
                    icon={<ReloadOutlined />}
                    onClick={() => {
                        setShowStartScreen(true);
                        setGameEnded(false);
                    }}
                    style={{
                        height: '44px',
                        fontSize: '15px',
                        fontWeight: 600,
                        borderRadius: '10px',
                        padding: '0 24px',
                        background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                        border: 'none',
                        boxShadow: '0 4px 12px rgba(24, 144, 255, 0.3)'
                    }}
                >
                    Play Again
                </Button>
            </div>
        );
    }

    return (
        <div style={{ width: '100%' }}>
            {/* Progress Bar */}
            <div style={{
                marginBottom: '16px',
                padding: '12px 16px',
                background: 'rgba(255, 255, 255, 0.95)',
                borderRadius: '12px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
                border: '1px solid rgba(24, 144, 255, 0.2)'
            }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                    <Text style={{ fontSize: '14px', fontWeight: 600, color: '#1890ff' }}>
                        Question {currentQuestionIndex + 1} of 25
                    </Text>
                    <Text style={{ fontSize: '14px', fontWeight: 600, color: timeLeft <= 10 ? '#ff4d4f' : '#52c41a' }}>
                        ⏱️ {timeLeft}s
                    </Text>
                    <Text style={{ fontSize: '14px', fontWeight: 600, color: '#1890ff' }}>
                        Score: {score}
                    </Text>
                </div>
                <Progress 
                    percent={((currentQuestionIndex + 1) / 25) * 100} 
                    showInfo={false}
                    strokeColor={{
                        '0%': '#108ee9',
                        '100%': '#87d068',
                    }}
                />
            </div>

            {/* Question Card */}
            {currentQuestion && (
                <div style={{
                    padding: '24px',
                    background: 'rgba(255, 255, 255, 0.95)',
                    borderRadius: '12px',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                    border: '1px solid rgba(24, 144, 255, 0.2)',
                    marginBottom: '16px'
                }}>
                    <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center', 
                        gap: '12px',
                        marginBottom: '20px'
                    }}>
                        <Title level={4} style={{ margin: 0, color: '#1890ff', fontSize: '18px', textAlign: 'center', flex: 1 }}>
                            {currentQuestion.question}
                        </Title>
                        <Button
                            type={isReading ? "default" : "primary"}
                            shape="circle"
                            icon={<SoundOutlined />}
                            onClick={isReading ? stopReading : readAllOptions}
                            disabled={answered}
                            style={{
                                width: '40px',
                                height: '40px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                background: answered
                                    ? 'linear-gradient(135deg, #d9d9d9 0%, #bfbfbf 100%)'
                                    : isReading 
                                    ? 'linear-gradient(135deg, #ff4d4f 0%, #cf1322 100%)'
                                    : 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                                border: 'none',
                                boxShadow: answered ? 'none' : '0 2px 8px rgba(24, 144, 255, 0.3)',
                                animation: isReading ? 'pulse 1.5s ease-in-out infinite' : 'none',
                                cursor: answered ? 'not-allowed' : 'pointer',
                                opacity: answered ? 0.6 : 1
                            }}
                            title={answered ? 'Question answered' : (isReading ? 'Stop reading' : 'Read question and options')}
                        />
                    </div>
                    
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                        {currentQuestion.options.map((option, index) => {
                            const isCorrect = index === currentQuestion.correct;
                            const isSelected = selectedAnswer === index;
                            const showCorrect = showResult && isCorrect;
                            const showIncorrect = showResult && isSelected && !isCorrect;
                            const optionLabel = String.fromCharCode(65 + index); // A, B, C, D
                            
                            return (
                                <div key={index} style={{ position: 'relative' }}>
                                    <Button
                                        size="large"
                                        onClick={() => handleAnswer(index)}
                                        disabled={answered}
                                        style={{
                                            height: '50px',
                                            fontSize: '15px',
                                            textAlign: 'left',
                                            borderRadius: '10px',
                                            border: showCorrect 
                                                ? '2px solid #52c41a' 
                                                : showIncorrect 
                                                ? '2px solid #ff4d4f' 
                                                : '1px solid #d9d9d9',
                                            background: showCorrect
                                                ? 'linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%)'
                                                : showIncorrect
                                                ? 'linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%)'
                                                : 'white',
                                            color: showCorrect || showIncorrect ? '#000' : '#000',
                                            fontWeight: 500,
                                            paddingRight: '50px',
                                            width: '100%'
                                        }}
                                        icon={showCorrect ? <CheckCircleOutlined style={{ color: '#52c41a' }} /> : showIncorrect ? <CloseCircleOutlined style={{ color: '#ff4d4f' }} /> : null}
                                    >
                                        <span style={{ fontWeight: 600, marginRight: '8px' }}>{optionLabel}.</span>
                                        {option}
                                    </Button>
                                    <Button
                                        type="text"
                                        shape="circle"
                                        icon={<SoundOutlined style={{ fontSize: '14px' }} />}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (!answered) {
                                                readOption(option, index);
                                            }
                                        }}
                                        disabled={answered}
                                        style={{
                                            position: 'absolute',
                                            right: '8px',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            width: '32px',
                                            height: '32px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            background: answered ? 'rgba(217, 217, 217, 0.3)' : 'rgba(24, 144, 255, 0.1)',
                                            border: 'none',
                                            color: answered ? '#bfbfbf' : '#1890ff',
                                            cursor: answered ? 'not-allowed' : 'pointer',
                                            opacity: answered ? 0.5 : 1
                                        }}
                                        title={answered ? 'Question answered' : `Read option ${optionLabel}`}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}

            <style>{`
                @keyframes pulse {
                    0%, 100% {
                        transform: scale(1);
                        opacity: 1;
                    }
                    50% {
                        transform: scale(1.1);
                        opacity: 0.8;
                    }
                }
            `}</style>
        </div>
    );
};

export default PakistanQuiz;

